var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class BrowserHttpAdapter {
    send(config, method) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers();
            for (const key of Object.keys(config.headers)) {
                const values = config.headers[key];
                if (typeof values === 'string') {
                    headers.set(key, values);
                }
                else {
                    for (const value of values) {
                        headers.append(key, value);
                    }
                }
            }
            const searchParams = new URLSearchParams();
            for (const key of Object.keys(config.query)) {
                const values = config.query[key];
                if (typeof values === 'string') {
                    searchParams.set(key, values);
                }
                else {
                    for (const value of values) {
                        searchParams.append(key, value);
                    }
                }
            }
            const res = yield fetch(new URL(config.paths.join('/') + (Object.keys(config.query).length > 0 ? `?${searchParams.toString()}` : ''), !config.baseUrl ? window.location.href : config.baseUrl).toString(), {
                method,
                headers,
                body: config.body,
            });
            return {
                statusCode: res.status,
                bodyAsBlob() {
                    return res.blob();
                },
                header(name) {
                    var _a;
                    const headers = (_a = res.headers
                        .get(name)) === null || _a === void 0 ? void 0 : _a.split(',').map((h) => h.trim());
                    if (!headers) {
                        return null;
                    }
                    if (headers.length === 1) {
                        return headers[0];
                    }
                    return headers;
                },
                hasHeaderValue(name, value) {
                    var _a;
                    const headers = (_a = res.headers
                        .get(name)) === null || _a === void 0 ? void 0 : _a.split(',').map((h) => h.trim());
                    if (!headers) {
                        return false;
                    }
                    return headers.some((h) => h === value);
                },
                headerAsString(name) {
                    return res.headers.get(name);
                },
                bodyAsString() {
                    return res.text();
                },
                bodyAsJson() {
                    return res.json();
                },
            };
        });
    }
}
